import axios from "axios";
import { Apis } from "constants/apis";
import { getToken } from "utils/token";

const updateCoupon = async (payload: any) => {
    const { data } = await axios.put(Apis.UPDATE_COUPON, payload, { headers: { Authorization: getToken() } })
    return data
}
export default updateCoupon